module.exports = __webpack_public_path__ + "media/newstyle/images/icon-book-purple-c66fa1ab33c81dc57ae2d6073de2eec4.svg";